module.exports = __webpack_public_path__ + "static/media/кардио - велотренажер.84d1c622.JPG";